import Avatar, { Badge } from 'components/Avatar'
import Icon from 'components/Icon'
import { IconButton } from 'components/IconButton'
import Tooltip from 'components/Tooltip'
import JobViewModel from 'jobs/views/JobRoot/Job/JobViewModel'
import { observer } from 'mobx-react'
import React from 'react'
import { timeago } from 'utils/date-util'
import styles from './ConversationHeader.sass'

interface ConversationHeaderProps {
  vm: JobViewModel
}

export default observer(function ConversationHeader({
  vm,
}: ConversationHeaderProps) {
  const timeAgoText = timeago(
    vm.participantMemberToDisplay?.lastSeen ?? new Date(),
  )

  return (
    <div className={styles.root}>
      <div className={styles.container}>
        <div className={styles.participant}>
          <div className={styles.avatarContainer}>
            <Avatar
              badge={
                vm.championClient?.collaborator.member.user.online
                  ? Badge.Online
                  : Badge.Offline
              }
              size={38}
              subject={
                vm.participantMemberToDisplay ??
                vm.championClient?.collaborator.member
              }
            />
          </div>
          <div className={styles.memberInfo}>
            <div className={styles.displayName}>
              {vm.participantMemberToDisplay?.displayName ??
                vm.championClient?.collaborator.member.displayName}
            </div>
            {vm.canViewLastSeenInfoInChat && (
              <div className={styles.lastSeen}>
                {vm.participantMemberToDisplay
                  ? timeAgoText === 'now'
                    ? 'Active now'
                    : `Last seen ${timeAgoText} ago`
                  : 'Unclaimed'}
              </div>
            )}
          </div>
        </div>

        <div className={styles.actions}>
          {vm.conversationVM.canRefreshManually && (
            <Tooltip content="Refresh conversation" placement="bottom">
              <IconButton
                variant="ghost"
                onClick={() => vm.conversationVM.fetchLatestMessages()}
              >
                <Icon name="loader-arrows" />
              </IconButton>
            </Tooltip>
          )}
          <Tooltip
            content={
              vm.conversationVM.conversation.muted
                ? 'Unmute conversation'
                : 'Mute conversation'
            }
            placement="bottom"
          >
            <IconButton
              variant="ghost"
              onClick={() => vm.conversationVM.toggleMute()}
            >
              <Icon
                name={
                  vm.conversationVM.conversation.muted
                    ? 'notifications-thick-muted'
                    : 'notifications-thick'
                }
              />
            </IconButton>
          </Tooltip>
          {vm.job.canDownloadConversation && (
            <Tooltip content="Download conversation history" placement="bottom">
              <IconButton
                variant="ghost"
                onClick={vm.conversationVM.downloadConversation}
                data-test={`download-conversation-new`}
              >
                <Icon name="download" />
              </IconButton>
            </Tooltip>
          )}
        </div>
      </div>
    </div>
  )
})
